import cloneDeep from "lodash/cloneDeep";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { debounce } from "lodash";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import EventImagePreview from "@/components/Events/EventImagePreview/EventImagePreview.vue";
import KisCommitteeEditDialog from "@/components/KIS/KisCommitteeEditDialog/KisCommitteeEditDialog.vue";
import KisList from "@/components/KIS/KisList/KisList.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultItem = { name: "", description: "", active: true, pictures: [] };

export default {
  name: "KisCommittee",
  components: {
    KisCommitteeEditDialog,
    KisList,
    EventImagePreview,
    ValidationDialog,
    TreeViewSelection
  },
  data: () => ({
    loading: false,
    editedItem: {},
    editDialog: false,
    filter: { name: "", limit: 10 },
    headers: [
      { text: "Name", value: "name" },
      { text: "Zuletzt geändert am", value: "updatedAt" },
      { text: "Aktiv", value: "active" },
      { text: "Aktionen", sortable: false, value: "actions" }
    ]
  }),
  async mounted() {
    this.loading = true;
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    await this.$store.dispatch("getCommittees", this.filter);
    await this.getAllPersons();
    await this.$store.dispatch("getAllUsers");

    this.loading = false;
  },
  methods: {
    async getAllPersons() {
      const limit = 100;

      await this.$store.dispatch("getPersons", {
        skip: this.persons.length,
        limit,
        getAll: true
      });
    },
    editItem(item) {
      this.editDialog = true;
      this.editedItem = cloneDeep(item);
    },
    addNewCommittee() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = true;
    },
    copyItem(item) {
      this.editedItem = cloneDeep(item);
      delete this.editedItem?._id;
      this.editDialog = true;
    },
    setCommittee(item) {
      this.editedItem = item;
    },
    closeDialog() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = false;
    },
    async getCommittees(filter) {
      await this.$store.dispatch("getCommittees", filter);
    },
    async updateCommittee(committee) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.kis_api_client_url}committee/${committee._id}`,
          committee,
          {
            params: {
              principal_id: committee.principal_id
            },
            headers
          }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          this.setCommittee(response.data);
          await this.$store.dispatch("getCommittees", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async deleteCommittee(committee) {
      try {
        const confirm = await this.$confirm(
          "Möchten Sie dieses Gremium wirklich löschen?",
          confirmWarningConfig
        );
        if (confirm) {
          const headers = getTokenHeader();
          if (!this.editedItem.principal_id)
            this.editedItem.principal_id = this.currentPrincipal;
          const response = await axios.delete(
            `${env.kis_api_client_url}committee/${committee._id}`,
            {
              params: {
                principal_id: committee.principal_id
              },
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
            await this.$store.dispatch("getCommittees", this.filter);
          } else {
            console.error(response);
            await this.$store.dispatch(
              "createError",
              "Es ist ein Fehler aufgetreten!"
            );
          }
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    setFilterPage(page) {
      this.filter.page = page;
    },
    setFilterLimit(limit) {
      this.filter.limit = limit;
      this.filter.itemsPerPage = limit;
      localStorage.setItem("itemsPerPage", limit);
    },
    applySearchText: debounce(async function() {
      if (this.filter.name.length >= 3 || !this.filter.name.length)
        await this.$store.dispatch("getCommittees", this.filter);
    }, 500)
  },

  computed: {
    committees() {
      return this.$store.state.committees;
    },
    persons() {
      return this.$store.state.persons;
    },
    subjectAreas() {
      return this.$store.state.subjectAreas?.map(
        area =>
          (area = {
            title: area.name,
            ...area
          })
      );
    },
    personCount() {
      return this.$store.state.personCount;
    },
    committeeCount() {
      return this.$store.state.committeeCount;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  }
};
